import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { Observable } from "rxjs";
import { VisionService } from "../vision.service";
import { VisionPageRoute } from "../vision-page/vision-page.component";

@Component({
    selector: "adapt-team-vision-dashboard-element",
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: "./team-vision-dashboard-element.component.html",
})
export class TeamVisionDashboardElementComponent extends BaseComponent implements OnChanges {
    @Input() public team?: Team;
    public visionSummary?: string;
    public visionUrl$?: Observable<string>;

    public constructor(
        elementRef: ElementRef,
        private visionService: VisionService,
    ) {
        super(elementRef);
    }

    public ngOnChanges(): void {
        if (this.team) {
            this.visionService.getSummaryIntegratedVisionByTeam(this.team.teamId).pipe(
                this.takeUntilDestroyed(),
            ).subscribe((summary) => {
                this.isInitialised = true;
                this.visionSummary = summary?.extensions.isCompleted
                    ? summary.statement
                    : undefined;
            });

            this.visionUrl$ = VisionPageRoute.getRoute({ teamId: this.team.teamId });
        }
    }
}
